import { createRoutine } from 'redux-saga-routines';
import { Action } from 'redux-actions';

import {
    genApiSchemaState,
    setSingleState,
    wrapWithModule,
    RESET_APP_ACTION,
} from 'src/utils/redux';
import { RetrieveCountriesState, Countries } from './types';

import { ServerError } from '../types';

const wrapWithNamespace = wrapWithModule('modules/retrieveCountries');
export const retrieveCountriesAction = createRoutine(
    wrapWithNamespace('retrieve'),
);

const defaultCountries: Countries = [
    { code: '', name: '', id: { organizationId: '', pointId: '' } },
];
const updateInitialState: RetrieveCountriesState =
    genApiSchemaState<RetrieveCountriesState>({
        data: defaultCountries,
    });

const retrieveCountriesReducer = (
    state = updateInitialState,
    { type, payload }: Action<Countries>,
): RetrieveCountriesState => {
    const handler = HANDLERS[type];
    return handler ? handler(state, payload) : state;
};

const handleTrigger = setSingleState('loading', true);

const handleSuccess = (state: RetrieveCountriesState, payload: Countries) => ({
    ...state,
    error: undefined,
    loading: false,
    data: { ...state.data, ...payload },
});

const handleError = (_: RetrieveCountriesState, payload: ServerError) => ({
    ...updateInitialState,
    error: payload,
});

const HANDLERS = {
    [retrieveCountriesAction.TRIGGER]: handleTrigger,
    [retrieveCountriesAction.SUCCESS]: handleSuccess,
    [retrieveCountriesAction.FAILURE]: handleError,
    [RESET_APP_ACTION]: () => updateInitialState,
};

export default retrieveCountriesReducer;
